export const TEXT_LANGUAGES = [
  {
    id: "ENGLISH",
    short: "EN",
    pretty: "Englisch",
    prettyTranslationKey: "language_english",
    accentBg: "#E8EDFF",
    accentText: "#1e3a8a",
  },
  {
    id: "ESPERANTO",
    short: "EO",
    pretty: "Esperanto",
    prettyTranslationKey: "language_esperanto",
    accentBg: "#E9FBEF",
    accentText: "#166534",
  },
  {
    id: "FRENCH",
    short: "FR",
    pretty: "Französisch",
    prettyTranslationKey: "language_french",
    accentBg: "#FFE9F0",
    accentText: "#9d174d",
  },
  {
    id: "GERMAN",
    short: "DE",
    pretty: "Deutsch",
    prettyTranslationKey: "language_german",
    accentBg: "#FFF4E5",
    accentText: "#92400e",
  },
  {
    id: "GREEK",
    short: "GRC",
    pretty: "Griechisch",
    prettyTranslationKey: "language_greek",
    accentBg: "#E8F8FF",
    accentText: "#0f4c81",
  },
  {
    id: "GREEK_LATIN_TRANSCRIPTION",
    short: "GRC (Latin)",
    pretty: "Griechisch (Latin Transkription)",
    prettyTranslationKey: "language_greek_latin_transcription",
    accentBg: "#EEF2FF",
    accentText: "#4338ca",
  },
  {
    id: "ITALIAN",
    short: "IT",
    pretty: "Italienisch",
    prettyTranslationKey: "language_italian",
    accentBg: "#E9F7EF",
    accentText: "#166534",
  },
  {
    id: "PORTUGUESE_FROM_BRAZIL",
    short: "BR",
    pretty: "Portugiesisch (Brasilien)",
    prettyTranslationKey: "language_portuguese_brazil",
    accentBg: "#E6FFF4",
    accentText: "#047857",
  },
  {
    id: "PORTUGUESE_FROM_PORTUGAL",
    short: "PT",
    pretty: "Portugiesisch (Portugal)",
    prettyTranslationKey: "language_portuguese_portugal",
    accentBg: "#ECF4FF",
    accentText: "#1d4ed8",
  },
  {
    id: "RUSSIAN",
    short: "RU",
    pretty: "Russisch",
    prettyTranslationKey: "language_russian",
    accentBg: "#F3E8FF",
    accentText: "#6b21a8",
  },
  {
    id: "RUSSIAN_LATIN_TRANSCRIPTION",
    short: "RU (Latin)",
    pretty: "Russisch (Latin Transkription)",
    prettyTranslationKey: "language_russian_latin_transcription",
    accentBg: "#F5F3FF",
    accentText: "#7c3aed",
  },
  {
    id: "SPANISH",
    short: "SP",
    pretty: "Spanisch",
    prettyTranslationKey: "language_spanish",
    accentBg: "#FFF1E6",
    accentText: "#c2410c",
  },
];

export const NATIVE_LANGUAGE_LABELS: Record<string, string> = {
  ENGLISH: "English",
  ESPERANTO: "Esperanto",
  FRENCH: "Français",
  GERMAN: "Deutsch",
  GREEK: "Ελληνικά",
  GREEK_LATIN_TRANSCRIPTION: "Ελληνικά (Latin)",
  ITALIAN: "Italiano",
  PORTUGUESE_FROM_BRAZIL: "Português (Brasil)",
  PORTUGUESE_FROM_PORTUGAL: "Português (Portugal)",
  RUSSIAN: "Русский",
  RUSSIAN_LATIN_TRANSCRIPTION: "Русский (Latin)",
  SPANISH: "Español",
};

export const ENABLED_LANGUAGE_SPACE_IDS = [
  "ENGLISH",
  "FRENCH",
  "GERMAN",
  "ITALIAN",
] as const;

export const READ_TODAY_CTA_BY_LANGUAGE: Record<string, string> = {
  ENGLISH: "Read today's chapter",
  GERMAN: "Heutiges Kapitel lesen",
  FRENCH: "Lire le chapitre du jour",
  ITALIAN: "Leggi il capitolo di oggi",
};

export const CONTINUE_READING_CTA_BY_LANGUAGE: Record<string, string> = {
  ENGLISH: "Continue reading",
  GERMAN: "Weiterlesen",
  FRENCH: "Continuer à lire",
  ITALIAN: "Continua a leggere",
};

export const CONTINUE_READING_LOADING_BY_LANGUAGE: Record<string, string> = {
  ENGLISH: "Continuing text …",
  GERMAN: "Text wird erweitert …",
  FRENCH: "Texte en cours …",
  ITALIAN: "Testo in aggiornamento …",
};

export const CEFR_LEVEL_OPTIONS = [
  "A0",
  "A1",
  "A2",
  "B1",
  "B2",
  "C1",
  "C2",
] as const;

export const THINKERA_LEVEL = "THINKERA" as const;

export function isLevelAllowedForLanguage(
  level: string | null | undefined,
  _languageId: string | null | undefined,
): boolean {
  const normalizedLevel = (level ?? "").trim().toUpperCase();
  if (CEFR_LEVEL_OPTIONS.includes(normalizedLevel as (typeof CEFR_LEVEL_OPTIONS)[number])) {
    return true;
  }
  return normalizedLevel === THINKERA_LEVEL;
}

export function getLevelOptionsForLanguage(_languageId?: string | null | undefined): string[] {
  return [...CEFR_LEVEL_OPTIONS, THINKERA_LEVEL];
}

export function getLevelTranslationKey(level: string): string {
  const normalizedLevel = level.trim().toUpperCase();
  if (normalizedLevel === THINKERA_LEVEL) {
    return "onboarding_level_thinkera";
  }
  return `onboarding_level_${normalizedLevel.toLowerCase()}`;
}
